import { render, staticRenderFns } from "./UnitForm.vue?vue&type=template&id=10ecd276&scoped=true&"
import script from "./UnitForm.vue?vue&type=script&lang=ts&"
export * from "./UnitForm.vue?vue&type=script&lang=ts&"
import style0 from "./UnitForm.vue?vue&type=style&index=0&id=10ecd276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ecd276",
  null
  
)

export default component.exports